<template>
    <v-dialog v-model="dialog" persistent max-width="1000px">
        <v-btn flat slot="activator"><v-icon left>edit</v-icon>Edit</v-btn>
        <v-card>
            <form v-on:submit.prevent="create">
                <v-card-title>
                    <span class="headline">Add new contact</span>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs6 s6 md6>
                                <v-text-field
                                        v-validate="'required'"
                                        v-model="data.name"
                                        :error-messages="errors.collect('data.name')"
                                        label="Name"
                                        data-vv-name="data.name"
                                        browser-autocomplete="off"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs6 s6 md6>
                                <v-text-field
                                        v-validate="'required'"
                                        v-model="data.email"
                                        :error-messages="errors.collect('data.email')"
                                        label="Email"
                                        data-vv-name="data.email"
                                        browser-autocomplete="off"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs6 s6 md6>
                                <v-text-field
                                        v-validate="''"
                                        v-model="data.phone"
                                        :error-messages="errors.collect('data.phone')"
                                        label="Phone"
                                        data-vv-name="data.phone"
                                        browser-autocomplete="off"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs6 s6 md6>
                                <v-text-field
                                        v-validate="''"
                                        v-model="data.position"
                                        :error-messages="errors.collect('data.position')"
                                        label="Position"
                                        data-vv-name="data.position"
                                        browser-autocomplete="off"
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click.native="cancel()">Cancel</v-btn>
                    <v-btn color="blue darken-1" flat type="submit">Save</v-btn>
                </v-card-actions>
            </form>
        </v-card>
    </v-dialog>
</template>

<script>
    import { DICCIONARIO } from '../../../../diccionario';

    export default {
        props: ['contact'],
        data: () => ({
            dialog: false,
            data : null,
        }),
        created () {
            this.data = Object.assign({}, this.contact);
        },
        mounted () {
            this.$validator.localize('en', DICCIONARIO)
        },
        methods: {
            create () {
                this.$validator.validateAll().then((result) => {
                    if(result){
                        this.$emit('update', this.data);
                        this.data = this.contact;
                        this.dialog = false
                    }
                });
            },
            cancel () {
                this.dialog = false;
                this.data = this.contact;
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/clients/components/EditContactModalComponent.vue